<template>
  <!-- 线上诊断--诊断弹窗 -->
  <el-dialog
    id="ff"
    :center="true"
    :close-on-click-modal="false"
    title="线上诊断报告"
    :visible.sync="showEdit"
    :append-to-body="true"
    @close="closeEditDialog"
    width="53%"
  >
    <el-form
      :rules="rules"
      ref="diagnosis"
      :model="diagnosis"
      label-width="100px"
    >
      <el-form-item label="学生姓名">
        <el-input
          v-model="diagnosis.studentName"
          style="width: 100%;"
        ></el-input>
      </el-form-item>
      <el-form-item label="学生年级" style="width: 100%;">
        <el-cascader
          style="width: 100%;"
          v-model="diagnosis.grade"
          :options="diagnosis.gradeList"
          :props="props"
        ></el-cascader>
      </el-form-item>
      <el-form-item label="学生性别">
        <el-radio-group v-model="diagnosis.sex">
          <el-radio label="1">男</el-radio>
          <el-radio label="2">女</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="家庭住址">
        <el-input v-model="diagnosis.address" style="width: 100%;"></el-input>
      </el-form-item>
      <el-form-item label="家长电话">
        <el-input
          v-model="diagnosis.parentPhoneNumber"
          style="width: 100%;"
          @input="phoneChange"
          maxlength="11"
        ></el-input>
      </el-form-item>
      <el-form-item label="课程类别">
        <el-cascader
          style="width: 100%;"
          v-model="diagnosis.courseCategoryIds"
          :options="categoryList"
          :props="propsCategory"
        ></el-cascader>
      </el-form-item>
      <el-form-item label="线上诊断老师">
        <!-- <el-select
          style="width: 100%;"
          v-model="diagnosis.teacherIds"
          placeholder="请选择老师"
        >
          <el-option
            v-for="item in teachers"
            :key="item.id"
            :label="item.realname"
            :value="item.id"
          ></el-option>
        </el-select> -->
        <el-select multiple v-model="diagnosis.teacherIdArr" clearable style="width: 100%;" placeholder="请选择老师">
          <el-option v-for="item in teachers" :key="item.id" :label="item.realname" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="线上诊断时间">
        <el-date-picker
          v-model="diagnosis.startTimeDay"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="请选择线上诊断日期"
        >
        </el-date-picker>
        <el-time-picker
          is-range
          v-model="diagnosis.startTimeHour"
          value-format="HH:ss:mm"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          placeholder="选择线上诊断时间范围"
        >
        </el-time-picker>
      </el-form-item> -->
      <el-form-item label="线上诊断时间">
        <el-date-picker
          style="width: 182px;"
          v-model="diagnosis.startTimeDay"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="请选择线上诊断日期"
        >
        </el-date-picker>
        <!-- <el-time-select
          style="width: 190px;"
          placeholder="起始时间"
          v-model="diagnosis.startTimeHour"
          :picker-options="{
            start: '06:00',
            step: '00:15',
            end: '24:00'
          }"
        >
        </el-time-select> -->
        <mz-time-select @clean="clean" style="width: 190px;  display:inline-block" :childPlaceholder="'开始时间'" :timePeriod="'start'"  @startTimeSelect="startTimeSelect" v-model="diagnosis.startTimeHour" :valueTime="diagnosis.startTimeHour"></mz-time-select>
        <span style="margin-left:5px"></span>
        <mz-time-select @clean="clean" style="width: 190px;display:inline-block" :childPlaceholder="'结束时间'" :timePeriod="'end'" @startTimeSelect="startTimeSelect" v-model="diagnosis.endTimeHour" :valueTime="diagnosis.endTimeHour"></mz-time-select>
        <!-- <el-time-select
          style="width: 190px;"
          placeholder="结束时间"
          v-model="diagnosis.endTimeHour"
          :picker-options="{
            start: '06:00',
            step: '00:15',
            end: '24:00'
          }"
        >
        </el-time-select> -->
      </el-form-item>
      <!-- <el-form-item label="线上诊断费用">
        <el-input
          v-model="diagnosis.diagnosisPay"
          placeholder="请输入诊断费用"
        ></el-input>
      </el-form-item> -->
      <!-- 1待诊断 2已诊断     下拉框一会写-->
      <el-form-item label="线上诊断状态">
        <el-select
          style="width: 100%;"
          v-model="diagnosis.stautsId"
          placeholder="请选择线上诊断状态"
        >
          <el-option
            v-for="item in onlineStatus"
            :key="item.id"
            :label="item.label"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- 1待沟通 2沟通 3已收款    下拉框一会写-->
      <!-- <el-form-item label="沟通状态">
        <el-select
          style="width: 100%;"
          v-model="diagnosis.talkId"
          placeholder="请选择沟通状态"
        >
          <el-option
            v-for="item in talkStatus"
            :key="item.id"
            :label="item.label"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="线上诊断模板">
        <el-select
          style="width: 100%;"
          v-model="diagnosis.templateId"
          placeholder="请选择线上诊断模板"
          @change="getTemplate(diagnosis.templateId)"
        >
          <el-option
            v-for="item in Templates"
            :key="item.templateId"
            :label="item.templateName"
            :value="item.templateId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="diagnosis.diagnosisType === '1'"
        :label="diagnosis.tipsTitle"
      >
        <el-row>
          <!-- <el-upload
            ref="upload"
            style="display: inline-block;"
            :action="imageUrl2"
            :on-success="handleSuccess"
            :before-upload="beforeUpload"
          >
            <el-button type="text" style="margin-right: 50px">上传</el-button>
          </el-upload> -->

           <el-upload
              ref="upload"
              action="#"
              :beforeUpload="beforeUpload"
              :on-remove="handleRemove"
              :file-list="fileLists"
              :http-request="handleUpload"
              :auto-upload="true"
              drag
              :limit="1">
              <!-- <img v-if="screenshot" :src="screenshot" style="width: 100%;height: 100%;" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
              <el-button type="text" style="margin-right: 50px">上传</el-button>
            </el-upload>


          <a :href="diagnosis.diagnosisUrl" target="_blank" v-show="uploadFlag && diagnosis.diagnosisUrl"
            >下载</a
          >
        </el-row>
      </el-form-item>
      <el-form-item style="margin-top: -20px;" label="线上诊断信息">
        <el-form-item style="margin-top: 10px;">
          <el-button
            icon="el-icon-circle-plus-outline"
            @click="addInput"
          ></el-button>
          <el-button
            icon="el-icon-remove-outline"
            @click="removeItem"
          ></el-button>
        </el-form-item>
      </el-form-item>
      <el-form-item style="margin-left: -99px;    margin-top: -8px;">
        <el-form-item
          v-for="(item, index) in diagnosis.diagnosisDetailArr"
          :key="index"
        >
          <el-form-item :label="'问题' + (index + 1)">
            <el-input
              :disabled="true"
              v-model="item.question"
              size="small"
              style="width: 80%;"
              placeholder="请输入问题"
            ></el-input>
          </el-form-item>
          <el-form-item :label="'回答' + (index + 1)">
            <el-input
              type="textarea"
              :rows="2"
              v-model="item.tips"
              size="small"
              style="width: 80%;"
              :placeholder="item.answer"
            ></el-input>
          </el-form-item>
        </el-form-item>
      </el-form-item>
      <el-form-item label="备注">
        <el-input
          v-model="diagnosis.node"
          type="textarea"
          :rows="2"
          placeholder="请输入内容"
        >
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="closeEditDialog">取消</el-button>
      <el-button size="small" type="primary" @click="saveEditForm"
        >保存</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../../config/api";
import { put, signatureUrl, getFileNameUUID } from "../../utils/oss";
export default {
  components: {},
  data() {
    return {
      uploadFlag: false,
      imageUrl2: `${apiBaseUrl}/customerinformation/importFile`,
      Templates: [], //模板集合
      teachers: [], //老师集合
      categoryList: [], //课程集合
      rules: {},
      showEdit: false,
      onlineStatus: [
        {
          id: 1,
          label: "待诊断",
          value:1
        },
        {
          id: 2,
          label: "已诊断",
          value:2
        }
      ],
      talkStatus: [
        {
          id: 1,
          label: "待沟通",
          value:1
        },
        {
          id: 2,
          label: "已沟通",
          value:2
        },
        {
          id: 3,
          label: "已收款",
          value:3
        }
      ],
      propsCategory: {
        label: "categoryName",
        children: "children",
        value: "id"
      },
      props: {
        label: "gradeName",
        children: "children",
        value: "id"
      },
      diagnosis: {
        tipsTitle: "",
        diagnosisId: "",
        templateId: "",
        teacherId: "",
        teacherIdArr:[],
        studentId: "",
        startTimeDay: "",
        startTimeHour: "",
        endTimeHour: "",
        diagnosisTimeArr: [],
        onlineTime: [],
        offlineTime: [],
        customerId: "",
        customerPaymoney: "",
        diagnosisUrl: "",
        diagnosisStatus: "",
        diagnosisType: "",
        diagnosisPay:"",
        studentName: "", //学生姓名
        gradeList: [], //年级
        grade: [], //年级id
        sex: "", //性别
        address: "", //地址
        parentPhoneNumber: "", //家长电话
        stautsId: 1, //诊断状态
        talkId: 1, //沟通状态
        node: "", //备注
        courseCategoryIds: [],
        diagnosisDetailArr: [
          {
            question: "",
            tips: "",
            answer: ""
          }
        ]
      },
      template: {
        templateStatus: 1
      },
      fileLists:[],
    };
  },
  computed: {},
  watch: {},
  methods: {
    phoneChange() {
      this.diagnosis.parentPhoneNumber = this.diagnosis.parentPhoneNumber.replace(/[^\d]/g, "");
      if (this.diagnosis.parentPhoneNumber.length > 11) {
        this.diagnosis.parentPhoneNumber = this.diagnosis.parentPhoneNumber.substr(0, 11);
      }
      let reg = /^1[3456789]\d{9}$/;
      if (this.diagnosis.parentPhoneNumber.length >= 11 && !reg.test(this.diagnosis.parentPhoneNumber)) {
         this.$notify({
          title: '警告',
          message: '请输入正确的手机号码格式',
          type: 'warning'
        });
      }
    },
    startTimeSelect(val,row){
      if (val == "start") {
        this.diagnosis.startTimeHour = row
      }else{
        this.diagnosis.endTimeHour = row
      }
    },
    clean (val) {
      if (val == "start") {
        this.diagnosisOff.startTimeHour = ''
      } else {
        this.diagnosisOff.endTimeHour = ''
      }
    },
    //绑定课程id
    bingCategory() {
      if (this.order.diagnosisAllPayMoney == 2000) {
        this.order.courseCategoryIds = [25, 26];
      }
    },
    saveEditForm() {
      //点击保存的时候把日期时间写在同一个数组中
      this.diagnosis.onlineTime = [
        this.diagnosis.startTimeDay,
        this.diagnosis.startTimeHour,
        this.diagnosis.endTimeHour
      ];
      this.diagnosis.offlineTime = [];
      // if (
      //   this.diagnosis.diagnosisDetailArr.length <= 0 &&
      //   this.diagnosis.diagnosisUrl === ""
      // ) {
      //   this.$message({
      //     message: "请上传文件或者输入问题",
      //     type: "error"
      //   });
      //   return;
      // }
      this.diagnosis.diagnosisTimeArr.push(
        this.diagnosis.startTimeDay,
        this.diagnosis.startTimeHour
      );
      if (this.diagnosis.diagnosisId === "") {
        this.diagnosis.diagnosisStatus = 1;

        axios.post(`${apiBaseUrl}/diagnosis/add`, this.diagnosis,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }).then(res => {
          if (res.data.code === 200) {
            this.fileLists = []
            this.$message({
              message: "保存成功",
              type: "success"
            });
            this.showEdit = false;
            this.$emit("refreshOrder");
          } else {
            this.$message({
              message: "保存失败",
              type: "error"
            });
          }
        });
      } else {
        this.diagnosis.diagnosisStatus = 1;
        axios
          .put(`${apiBaseUrl}/diagnosis/update`, this.diagnosis,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then(res => {
            if (res.data.code === 200) {
              this.fileLists = []
              this.$message({
                message: "保存成功",
                type: "success"
              });
              this.$emit("refreshOrder");
              this.showEdit = false;
            } else {
              this.$message({
                message: "保存失败",
                type: "error"
              });
            }
          });
      }
    },
    handleSuccess(response, file, fileList) {
      this.diagnosis.diagnosisUrl = "https://www.mzkt.top/img/" + response.data.url;
      this.uploadFlag = true;
      this.screenshot = URL.createObjectURL(file.raw);
    },
    beforeUpload(file) {
      // 在上传之前对文件大小进行检查
      // 可以根据需求自定义文件大小限制，或者设置为无限制
      // 例如：限制文件大小为10MB
      const maxSize = 100 * 1024 * 1024; // 100MB
      if (file.size > maxSize) {
        this.$message.error("文件大小超过限制");
        return false; // 阻止文件上传
      }
    },

    getFileName(name) {
      return name.substring(name.lastIndexOf("."));
    },

    handleUpload(option) {
      var obj = option.file.name;
      var index = obj.lastIndexOf(".");
      obj = obj.substring(index, obj.length);
      // 生成的文件名，保留文件后缀名，进行拼接
      let objName = getFileNameUUID() + this.getFileName(option.file.name);
      // 调用 ali-oss 中的方法,flieName是存放的文件夹名称，可自己定义
      put(`mz_pc/${objName}`, option.file).then((res) => {
        console.log(res);
        this.uploadFlag = true;
        this.diagnosis.diagnosisUrl = res.url
        this.screenshot = res.url
        // 上传成功之后，转换真实的地址
        signatureUrl(`mz_pc/${objName}`).then((res) => {
          console.log(res);
        });
      });
    },
    handleRemove(file, fileList) {
      this.fileLists = fileList;
      this.diagnosis.diagnosisUrl = ""
    },

    //添加输入框
    addInput() {
      if (this.diagnosis.diagnosisDetailArr == null) {
        this.diagnosis.diagnosisDetailArr = [
          {
            question: "",
            tips: "",
            answer: ""
          }
        ];
      } else {
        if (this.diagnosis.diagnosisDetailArr.length >= 1) {
          this.diagnosis.diagnosisDetailArr.push({
            question: "",
            tips: "",
            answer: ""
          });
        } else {
          this.diagnosis.diagnosisDetailArr = [
            {
              question: "",
              tips: "",
              answer: ""
            }
          ];
        }
      }
    },
    //减少输入框
    removeItem() {
      if (this.diagnosis.diagnosisDetailArr.length > 1) {
        this.diagnosis.diagnosisDetailArr.pop();
      } else {
        this.diagnosis.diagnosisDetailArr.splice(
          0,
          this.diagnosis.diagnosisDetailArr.length
        );
      }
    },
    //初始化
    init(id) {
      this.diagnosis.customerId = id;
      this.diagnosis.diagnosisStatus = 1;
      const data = {
        customerId: this.diagnosis.customerId,
        diagnosisStatus: 1
      };
      axios.post(`${apiBaseUrl}/diagnosis/getOne`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }).then(res => {
        this.getCustomer(this.diagnosis.customerId);
        if (res.data.code === 200 && res.data.data !== null) {
          this.diagnosis.stautsId = res.data.data.stautsId; //诊断状态
          this.diagnosis.talkId = res.data.data.talkId; //沟通状态
          this.diagnosis.node = res.data.data.node; //备注
          this.diagnosis.diagnosisId = res.data.data.diagnosisId;
          this.diagnosis.customerId = res.data.data.customerId;
          this.diagnosis.templateId = res.data.data.templateId;
          this.diagnosis.tipsTitle = res.data.data.tipsTitle;
          // this.diagnosis.teacherId = res.data.data.teacherId;
          if (res.data.data.diagnosisUrl !==null && res.data.data.diagnosisUrl !==''){
            this.uploadFlag = true
            this.diagnosis.diagnosisUrl = res.data.data.diagnosisUrl
          }
          this.diagnosis.startTimeDay = JSON.parse(
            res.data.data.diagnosisTime
          )[0];
          this.diagnosis.startTimeHour = JSON.parse(
            res.data.data.diagnosisTime
          )[1];
          this.diagnosis.diagnosisPay = res.data.data.diagnosisPay;
          this.diagnosis.diagnosisType = res.data.data.diagnosisType + "";
          this.diagnosis.diagnosisStatus = res.data.data.diagnosisStatus;
          this.diagnosis.diagnosisDetailArr = JSON.parse(
            res.data.data.diagnosisDetail
          );
          this.showEdit = true;
        } else {
          this.diagnosis.diagnosisId = "";
          this.diagnosis.templateId = "";
          this.diagnosis.teacherId = "";
          this.diagnosis.startTimeDay = "";
          this.diagnosis.startTimeHour = "";
          this.diagnosis.diagnosisUrl = "";
          this.diagnosis.diagnosisPay = "";
          this.diagnosis.diagnosisType = "";
          this.diagnosis.diagnosisStatus = "";
          this.diagnosis.studentName = "";
          this.diagnosis.diagnosisDetailArr = [
            {
              question: "",
              tips: "",
              answer: ""
            }
          ];
          this.showEdit = true;
        }
      });
    },
    closeEditDialog() {
      this.diagnosis.node = ""
      this.fileLists = []
      this.showEdit = false;
    },
    getTeachers() {
      axios
        .get(`${apiBaseUrl}/schedule/teacherDiagnosisList`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          this.teachers = res.data.data;
        })
        .catch(error => {
          this.$message({
            message: "获取老师列表失败",
            type: "error"
          });
        });
    },
    getTemplates() {
      axios.post(`${apiBaseUrl}/template/page`, this.template,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }).then(res => {
        if (res.data.code === 200) {
          this.Templates = res.data.data;
        } else {
          this.$message({
            message: res.data.message,
            type: "error"
          });
        }
      });
    },
    getGrade() {
      axios
        .get(`${apiBaseUrl}/grade/getGrade`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          if (res.data.data.length > 0) {
            this.diagnosis.gradeList = res.data.data;
          } else {
            this.$message({
              message: "获取年级列表失败",
              type: "error"
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //获取课程类别
    getCategoryList() {
      axios
        .get(`${apiBaseUrl}/category/list`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          this.categoryList = res.data.data;
        })
        .catch(error => {
          this.$message({
            message: "获取课程列表失败",
            type: "error"
          });
        });
    },
    //单个查询成单客资
    getCustomer(id) {
      axios
        .get(`${apiBaseUrl}/customerinformation/getOne/${id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(response => {
          console.log(response);
          // this.diagnosis.teacherId = response.data.data.list.teacherIdOnline; // 赋值
          if (response.data.code == 200) {
            if (response.data.data.list.teacherIdOnline == null && response.data.data.list.teacherIdOnlineArr == null) {
              this.diagnosis.teacherIdArr = []
            }else{
              if (response.data.data.list.teacherIdOnlineArr == []) {
                this.diagnosis.teacherIdArr = []
              }else{
                if (response.data.data.list.teacherIdOnlineArr) {
                  this.diagnosis.teacherIdArr = JSON.parse(response.data.data.list.teacherIdOnlineArr)
                }else{
                  this.diagnosis.teacherIdArr = [response.data.data.list.teacherIdOnline]
                }
              }
            }
            this.diagnosis.teacherId = null
          }


          this.diagnosis.studentName = response.data.data.list.customerStudent;
          this.diagnosis.parentPhoneNumber =
            response.data.data.list.parentPhoneNumber;
          this.diagnosis.sex = response.data.data.list.sex;
          this.diagnosis.grade = response.data.data.list.gradeIdArr2;
          this.diagnosis.address = response.data.data.list.address; //地址
          this.diagnosis.studentId = response.data.data.list.studentId;
          this.diagnosis.courseCategoryIds =
            response.data.data.list.categoryIdArr2;
          // this.diagnosis.diagnosisPay =
          //   response.data.data.list.customerAllpaymoney; // 赋值
          this.diagnosis.startTimeDay = JSON.parse(
            response.data.data.list.onlineTime
          )[0];
          this.diagnosis.startTimeHour = JSON.parse(
            response.data.data.list.onlineTime
          )[1];
          this.diagnosis.endTimeHour = JSON.parse(
            response.data.data.list.onlineTime
          )[2];
        })
        .catch(error => {
          console.error(error);
        });
      this.showEdit = true;
    },
    getTemplate(id) {
      axios.get(`${apiBaseUrl}/template/getById/${id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }).then(res => {
        this.diagnosis.diagnosisDetailArr = JSON.parse(
          res.data.data.templateSet
        );
        this.diagnosis.diagnosisType = res.data.data.templateType + "";
        this.diagnosis.tipsTitle = res.data.data.tipsTitle;
      });
    }
  },
  beforeCreate() {},

  created() {
    this.getTeachers();
    this.getTemplates();
    this.getGrade();
    this.getCategoryList();
  },

  beforeMount() {},

  mounted() {},

  beforeUpdate() {},

  updated() {},

  beforeDestroy() {},
  destroyed() {},

  activated() {}
};
</script>

<style scoped >

>>> .el-upload-dragger{
  width: 100px !important;
  height: 50px !important;
  padding-left: 30px;
}

/* 兼容移动端 */
@media screen and (max-width: 750px) {
  /* 兼容移动端 */
  #ff >>> .el-dialog {
    width: 83% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/manager/components/DiagnosisView.vue